var _circle, _circle2, _path, _path2, _g, _g2, _path3, _g3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect3, _rect4, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccountLiveViewEmptyState = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 286,
  height: 279,
  viewBox: "0 0 286 279",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 142.043,
  cy: 152.204,
  r: 110,
  fill: "url(#paint0_angular_7282_32570)",
  fillOpacity: 0.15
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_7282_32570",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 32,
  y: 42,
  width: 221,
  height: 221
}, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 142.043,
  cy: 152.204,
  r: 110,
  fill: "#D9D9D9"
}))), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_7282_32570)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M142.043 266.204C269.068 266.204 372.043 240.461 372.043 208.704C372.043 176.948 269.068 151.204 142.043 151.204C15.0175 151.204 -87.957 176.948 -87.957 208.704C-87.957 240.461 15.0175 266.204 142.043 266.204Z",
  fill: "url(#paint1_linear_7282_32570)"
})), /*#__PURE__*/React.createElement("mask", {
  id: "mask1_7282_32570",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 18,
  y: 225,
  width: 256,
  height: 55
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask2_7282_32570",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 18,
  y: 212,
  width: 256,
  height: 68
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M145.868 279.204C216.403 279.204 273.583 264.206 273.583 245.704C273.583 227.203 216.403 212.204 145.868 212.204C75.3324 212.204 18.1522 227.203 18.1522 245.704C18.1522 264.206 75.3324 279.204 145.868 279.204Z",
  fill: "url(#paint2_linear_7282_32570)"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask2_7282_32570)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M145.868 292.616C216.403 292.616 273.583 277.618 273.583 259.116C273.583 240.614 216.403 225.616 145.868 225.616C75.3324 225.616 18.1522 240.614 18.1522 259.116C18.1522 277.618 75.3324 292.616 145.868 292.616Z",
  fill: "url(#paint3_linear_7282_32570)"
})))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask1_7282_32570)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M143.587 265.629C214.123 265.629 271.303 250.631 271.303 232.129C271.303 213.628 214.123 198.629 143.587 198.629C73.0521 198.629 15.8719 213.628 15.8719 232.129C15.8719 250.631 73.0521 265.629 143.587 265.629Z",
  fill: "#46CC88"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "mask3_7282_32570",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 18,
  y: 231,
  width: 256,
  height: 46
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M145.868 276.166C216.403 276.166 273.583 266.101 273.583 253.685C273.583 241.269 216.403 231.204 145.868 231.204C75.3324 231.204 18.1522 241.269 18.1522 253.685C18.1522 266.101 75.3324 276.166 145.868 276.166Z",
  fill: "url(#paint4_linear_7282_32570)"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask3_7282_32570)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M113.047 316.87C113.047 316.87 112.395 303.251 113.047 297.387C113.699 291.457 112.395 287.547 111.092 283.638C109.789 279.728 107.834 275.167 110.441 269.954C113.047 264.741 113.699 264.741 113.047 262.134C112.395 259.528 107.979 260.399 109.282 256.489C110.585 252.579 115.002 244.997 116.305 241.935C117.608 238.872 116.305 231.769 116.305 231.769L163.873 230.206L171.04 232.812C171.04 232.812 171.04 242.586 172.343 246.496C173.647 250.405 178.208 255.618 178.208 260.18C178.208 264.741 173.647 273.212 174.298 276.47C174.95 279.728 175.602 287.547 175.602 295.367C175.602 303.186 174.95 315.566 174.95 315.566C174.95 315.566 158.66 325.992 141.718 325.992C124.776 325.992 113.047 316.87 113.047 316.87Z",
  fill: "url(#paint5_linear_7282_32570)"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M71.9126 252.467L77.5165 251.099C77.7771 251.033 77.7771 250.642 77.5165 250.577L71.9126 249.209C71.8474 249.209 71.7171 249.144 71.7171 249.013L70.3487 243.41C70.2836 243.149 69.8926 243.149 69.8275 243.41L68.4591 249.013C68.4591 249.079 68.3939 249.209 68.2636 249.209L62.6597 250.577C62.3991 250.642 62.3991 251.033 62.6597 251.099L68.2636 252.467C68.3287 252.467 68.4591 252.532 68.4591 252.662L69.8275 258.266C69.8926 258.527 70.2836 258.527 70.3487 258.266L71.7171 252.662C71.7823 252.532 71.8474 252.467 71.9126 252.467Z",
  fill: "white"
}))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M119.152 216.721C119.152 216.721 115.894 209.162 118.175 207.207C120.456 205.318 124.235 201.147 138.961 201.278C153.688 201.408 165.026 203.167 167.502 204.275C169.978 205.318 175.843 207.273 171.281 212.811C166.72 218.35 142.61 219.002 141.959 219.002C141.307 219.002 119.152 216.721 119.152 216.721Z",
  fill: "#0F1048"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M145.216 216.721C160.511 216.721 172.91 213.22 172.91 208.902C172.91 204.583 160.511 201.082 145.216 201.082C129.922 201.082 117.523 204.583 117.523 208.902C117.523 213.22 129.922 216.721 145.216 216.721Z",
  stroke: "#4447CB",
  strokeWidth: 6.99235,
  strokeMiterlimit: 10
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.7,
  d: "M119.812 247.021C119.812 247.021 126.98 252.885 136.754 254.84C146.528 256.795 173.552 257.113 173.552 257.113L169.986 243.763L140.663 246.369L119.812 247.021Z",
  fill: "url(#paint6_linear_7282_32570)"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M136.552 109.925C136.552 109.925 127.849 92.0336 126.529 90.8778C125.189 89.6598 110.095 79.2441 108.46 78.3921C106.826 77.54 96.7578 73.3302 96.7578 73.3302C96.7578 73.3302 92.2734 74.058 90.9954 76.5094C89.7174 78.9608 92.6815 84.0395 96.1455 86.3652C99.6096 88.6908 104.607 91.7637 104.607 91.7637C104.607 91.7637 111.799 100.294 113.611 100.407C113.611 100.407 121.672 116.041 125.871 118.75C130.071 121.459 136.552 109.925 136.552 109.925Z",
  fill: "url(#paint7_linear_7282_32570)"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M153.921 103.915C153.921 103.915 148.964 85.1187 148.005 82.073C147.047 79.0273 131.633 64.3402 130.64 63.3548C129.627 62.3072 116.871 54.9812 116.453 54.0879C116.036 53.1947 112.45 54.3911 110.548 55.9458C108.647 57.5004 108.983 60.7417 111.514 64.659C114.106 68.5567 123.22 75.5943 123.22 75.5943C123.22 75.5943 131.065 88.1542 133.88 88.6346C133.88 88.6346 134.508 103.875 139.242 109.149C139.284 109.067 146.847 110.308 153.921 103.915Z",
  fill: "url(#paint8_linear_7282_32570)"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M168.192 230.415C167.62 221.31 167.088 211.68 166.799 204.388C166.309 192.93 164.146 182.014 168.192 172.62C174.475 158.224 113.344 168.881 116.767 180.262C119.875 190.549 124.757 191.682 125.566 198.95C126.019 202.907 126.172 218.165 126.29 232.708C126.43 247.706 169.116 245.44 168.192 230.415Z",
  fill: "#FDBC9D"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M171.157 165.845C171.157 165.845 174.22 141.929 174.434 131.752C174.585 121.594 174.764 113.477 171.55 109.775C168.336 106.073 158.159 102.17 148.015 104.884C137.871 107.597 113.734 127.282 111.275 130.105C108.816 132.928 113.263 142.937 114.702 143.167C114.702 143.167 110.732 158.556 115.961 177.131C120.587 193.573 122.648 193.607 138.116 194.137C152.845 194.49 168.351 184.283 171.157 165.845Z",
  fill: "url(#paint9_linear_7282_32570)"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  d: "M173.281 113.125C173.281 113.125 175.204 86.0158 175.176 83.9751C175.211 81.9148 171.263 52.2127 170.926 48.9715C170.589 45.7302 168.564 43.635 165.944 43.7761C163.325 43.9173 160.608 46.1382 159.729 51.8113C158.849 57.4844 158.725 63.6031 160.109 65.8317C160.109 65.8317 158.217 80.2257 158.999 82.712C158.999 82.712 155.091 98.0817 156.601 105.052C156.582 104.99 159.214 117.482 173.281 113.125Z",
  fill: "url(#paint10_linear_7282_32570)"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M122.391 122.032C122.391 122.032 113.829 110.449 111.342 108.841C108.793 107.252 88.8867 97.3937 85.6455 97.7303C82.4042 98.067 81.8888 102.943 86.1156 107.692C90.3424 112.442 96.0476 113.858 96.0476 113.858C96.0476 113.858 100.145 120.151 104.806 119.982C104.806 119.982 109.706 131.215 111.704 131.269C113.702 131.324 121.891 128.474 122.391 122.032Z",
  fill: "url(#paint11_linear_7282_32570)"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  d: "M114.917 245.391C114.917 245.391 122.737 251.908 142.937 251.908C163.137 251.908 172.911 244.935 172.911 244.935L173.888 208.576C173.888 208.576 168.154 216.33 151.277 216.525C134.466 216.721 120.13 217.503 116.872 209.292L114.917 245.391Z",
  fill: "#6467EF"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 81.7562,
  y: 17.648,
  width: 14.8591,
  height: 28.6935,
  rx: 7.42957,
  transform: "rotate(16.8431 81.7562 17.648)",
  fill: "url(#paint12_linear_7282_32570)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 134.699,
  y: 33.8395,
  width: 14.8591,
  height: 28.6935,
  rx: 7.42957,
  transform: "rotate(16.8431 134.699 33.8395)",
  fill: "url(#paint13_linear_7282_32570)"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  d: "M19.9616 151.089L134.124 185.651C137.133 186.562 140.305 184.869 141.214 181.866L174.595 71.6031C175.504 68.6004 173.804 65.4322 170.795 64.5212L56.6323 29.9596C53.6232 29.0486 50.4514 30.7419 49.5423 33.7446L16.1676 143.987C15.2524 147.01 16.9525 150.178 19.9616 151.089Z",
  fill: "url(#paint14_linear_7282_32570)"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  d: "M18.4865 146.752L131.859 181.074C134.847 181.979 137.998 180.293 138.903 177.305L172.112 67.6088C173.016 64.6215 171.329 61.4708 168.341 60.5661L54.9689 26.2439C51.9806 25.3392 48.8294 27.0252 47.925 30.0124L14.7217 139.689C13.8112 142.696 15.4982 145.847 18.4865 146.752Z",
  fill: "#F8F8FF"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  d: "M36.9949 103.294L56.4555 109.186C56.9685 109.341 57.5094 109.052 57.6646 108.539L63.3651 89.7093C63.5203 89.1966 63.2308 88.6558 62.7178 88.5005L43.2572 82.609C42.7442 82.4537 42.2033 82.7431 42.0481 83.2558L36.3486 102.082C36.1923 102.598 36.4819 103.139 36.9949 103.294Z",
  fill: "#DCDFEC"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  d: "M28.1003 132.675L47.561 138.566C48.0739 138.721 48.6148 138.432 48.7701 137.919L54.4706 119.089C54.6258 118.577 54.3362 118.036 53.8233 117.881L34.3626 111.989C33.8497 111.834 33.3088 112.123 33.1535 112.636L27.4541 131.462C27.2978 131.978 27.5874 132.519 28.1003 132.675Z",
  fill: "#DCDFEC"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  d: "M72.6686 82.0215L92.1292 87.913C92.6422 88.0683 93.1831 87.7789 93.3383 87.2661L99.0388 68.4364C99.194 67.9236 98.9045 67.3828 98.3915 67.2275L78.9309 61.336C78.4179 61.1807 77.877 61.4701 77.7218 61.9829L72.0223 80.8091C71.866 81.3254 72.1556 81.8662 72.6686 82.0215Z",
  fill: "#DCDFEC"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  d: "M45.8894 73.9144L65.35 79.8059C65.863 79.9612 66.4039 79.6718 66.5591 79.1591L72.2596 60.3294C72.4149 59.8166 72.1253 59.2758 71.6123 59.1205L52.1517 53.229C51.6388 53.0737 51.0978 53.3631 50.9426 53.8758L45.2432 72.7021C45.0869 73.2183 45.3764 73.7591 45.8894 73.9144Z",
  fill: "#DCDFEC"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  d: "M63.774 111.402L83.2347 117.293C83.7476 117.448 84.2885 117.159 84.4438 116.646L90.1443 97.8165C90.2995 97.3037 90.0099 96.7629 89.497 96.6076L70.0363 90.7161C69.5234 90.5608 68.9825 90.8502 68.8272 91.363L63.1278 110.189C62.9715 110.705 63.2611 111.246 63.774 111.402Z",
  fill: "#DCDFEC"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  d: "M54.8796 140.782L74.3403 146.673C74.8532 146.828 75.3941 146.539 75.5494 146.026L81.2499 127.197C81.4051 126.684 81.1155 126.143 80.6026 125.988L61.1419 120.096C60.629 119.941 60.0881 120.23 59.9328 120.743L54.2334 139.569C54.0771 140.086 54.3667 140.626 54.8796 140.782Z",
  fill: "#DCDFEC"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  d: "M81.6798 148.895L101.14 154.787C101.653 154.942 102.194 154.653 102.35 154.14L108.05 135.31C108.205 134.797 107.916 134.257 107.403 134.101L87.9421 128.21C87.4292 128.054 86.8882 128.344 86.733 128.857L81.0336 147.683C80.8773 148.199 81.1669 148.74 81.6798 148.895Z",
  fill: "#DCDFEC"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  d: "M99.447 90.1283L118.908 96.0199C119.421 96.1751 119.962 95.8857 120.117 95.373L125.817 76.5433C125.972 76.0305 125.683 75.4897 125.17 75.3344L105.709 69.4429C105.196 69.2876 104.655 69.577 104.5 70.0898L98.8008 88.916C98.6445 89.4322 98.9341 89.9731 99.447 90.1283Z",
  fill: "#DCDFEC"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  d: "M90.5525 119.508L110.013 125.4C110.526 125.555 111.067 125.266 111.222 124.753L116.923 105.923C117.078 105.411 116.788 104.87 116.275 104.714L96.8148 98.823C96.3018 98.6677 95.7609 98.9571 95.6057 99.4699L89.9063 118.296C89.75 118.812 90.0395 119.353 90.5525 119.508Z",
  fill: "#DCDFEC"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  d: "M126.226 98.2354L145.686 104.127C146.199 104.282 146.74 103.993 146.896 103.48L152.596 84.6503C152.751 84.1375 152.462 83.5967 151.949 83.4414L132.488 77.5499C131.975 77.3946 131.434 77.684 131.279 78.1968L125.58 97.023C125.423 97.5393 125.713 98.0801 126.226 98.2354Z",
  fill: "#DCDFEC"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  d: "M117.331 127.615L136.792 133.507C137.305 133.662 137.846 133.373 138.001 132.86L143.702 114.03C143.857 113.518 143.567 112.977 143.054 112.821L123.594 106.93C123.081 106.775 122.54 107.064 122.384 107.577L116.685 126.403C116.529 126.919 116.818 127.46 117.331 127.615Z",
  fill: "#DCDFEC"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  d: "M117.523 208.901C117.523 213.202 129.904 216.721 145.216 216.721C160.529 216.721 172.91 213.202 172.91 208.901",
  stroke: "#4447CB",
  strokeWidth: 6.99235,
  strokeMiterlimit: 10
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  d: "M138.142 155.984C138.471 151.07 141.481 142.607 144.431 138.522C147.397 134.499 148.193 132.289 148.193 132.289C148.193 132.289 142.176 118.539 141.377 110.145C140.641 101.736 144.503 93.4648 150.133 92.0732C155.763 90.6816 156.232 92.5793 156.685 94.4138C157.139 96.2482 158.047 105.354 158.813 108.453C159.579 111.553 161.95 129.291 166.302 133.317C170.574 137.295 175.232 150.709 172.385 163.36C169.523 175.949 162.684 180.324 153.642 181.217C144.615 182.173 137.17 170.79 138.142 155.984Z",
  fill: "#FDBC9D"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.3,
  d: "M152.929 105.278C151.664 105.59 149.453 104.794 148.672 101.631C147.89 98.4685 147.812 98.1522 147.812 98.1522C147.812 98.1522 152.005 96.1089 153.27 95.7961C154.535 95.4834 155.864 95.1551 155.864 95.1551C155.864 95.1551 157.99 104.027 152.929 105.278Z",
  fill: "white"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 79.2147,
  y: 17,
  width: 14.8591,
  height: 28.6935,
  rx: 7.42957,
  transform: "rotate(16.6361 79.2147 17)",
  fill: "url(#paint15_linear_7282_32570)"
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 132.215,
  y: 33,
  width: 14.8591,
  height: 28.6935,
  rx: 7.42957,
  transform: "rotate(16.6361 132.215 33)",
  fill: "url(#paint16_linear_7282_32570)"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  d: "M213.84 187.25H163.566V195.5H213.84V187.25Z",
  fill: "#E5F4FF"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  d: "M163.276 195.532C170.056 195.532 175.552 190.036 175.552 183.256C175.552 176.476 170.056 170.98 163.276 170.98C156.496 170.98 151 176.476 151 183.256C151 190.036 156.496 195.532 163.276 195.532Z",
  fill: "url(#paint17_linear_7282_32570)"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  d: "M189.809 195.532C202.382 195.532 212.575 185.339 212.575 172.766C212.575 160.193 202.382 150 189.809 150C177.236 150 167.043 160.193 167.043 172.766C167.043 185.339 177.236 195.532 189.809 195.532Z",
  fill: "url(#paint18_linear_7282_32570)"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  d: "M213.972 195.532C222.474 195.532 229.366 188.64 229.366 180.138C229.366 171.636 222.474 164.744 213.972 164.744C205.47 164.744 198.578 171.636 198.578 180.138C198.578 188.64 205.47 195.532 213.972 195.532Z",
  fill: "url(#paint19_linear_7282_32570)"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  d: "M210.614 109.935H178.332V115.229H210.614V109.935Z",
  fill: "#E5F4FF"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  d: "M179.859 115.197C184.2 115.197 187.719 111.678 187.719 107.337C187.719 102.997 184.2 99.478 179.859 99.478C175.519 99.478 172 102.997 172 107.337C172 111.678 175.519 115.197 179.859 115.197Z",
  fill: "url(#paint20_linear_7282_32570)"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  d: "M196.907 115.229C204.979 115.229 211.522 108.686 211.522 100.614C211.522 92.5431 204.979 86 196.907 86C188.836 86 182.293 92.5431 182.293 100.614C182.293 108.686 188.836 115.229 196.907 115.229Z",
  fill: "url(#paint21_linear_7282_32570)"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  d: "M212.431 115.196C217.884 115.196 222.304 110.776 222.304 105.324C222.304 99.8709 217.884 95.4507 212.431 95.4507C206.979 95.4507 202.559 99.8709 202.559 105.324C202.559 110.776 206.979 115.196 212.431 115.196Z",
  fill: "url(#paint22_linear_7282_32570)"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  d: "M235.15 138.737H216.605V141.79H235.15V138.737Z",
  fill: "#E5F4FF"
})), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  d: "M217.514 141.758C220.007 141.758 222.028 139.737 222.028 137.244C222.028 134.751 220.007 132.729 217.514 132.729C215.021 132.729 213 134.751 213 137.244C213 139.737 215.021 141.758 217.514 141.758Z",
  fill: "url(#paint23_linear_7282_32570)"
})), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  d: "M227.289 141.758C231.917 141.758 235.668 138.007 235.668 133.379C235.668 128.751 231.917 125 227.289 125C222.662 125 218.91 128.751 218.91 133.379C218.91 138.007 222.662 141.758 227.289 141.758Z",
  fill: "url(#paint24_linear_7282_32570)"
})), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  d: "M236.222 141.791C239.361 141.791 241.906 139.246 241.906 136.107C241.906 132.968 239.361 130.424 236.222 130.424C233.084 130.424 230.539 132.968 230.539 136.107C230.539 139.246 233.084 141.791 236.222 141.791Z",
  fill: "url(#paint25_linear_7282_32570)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint0_angular_7282_32570",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(142.043 152.204) rotate(90) scale(110)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.135183,
  stopColor: "#649CEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.364696,
  stopColor: "#648BEF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.640625,
  stopColor: "#9964EF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.890009,
  stopColor: "#6467EF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_7282_32570",
  x1: 141.901,
  y1: 195.145,
  x2: 144.649,
  y2: 296.398,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6C6CFF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#6C6CFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_7282_32570",
  x1: 18.1748,
  y1: 245.704,
  x2: 273.606,
  y2: 245.704,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.3068,
  stopColor: "#6C6CFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5728,
  stopColor: "#19194F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8572,
  stopColor: "#6C6CFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_7282_32570",
  x1: 18.1748,
  y1: 259.116,
  x2: 273.606,
  y2: 259.116,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.3068,
  stopColor: "#6C6CFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5728,
  stopColor: "#19194F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8572,
  stopColor: "#6C6CFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_7282_32570",
  x1: 18.1748,
  y1: 253.685,
  x2: 273.606,
  y2: 253.685,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.3068,
  stopColor: "#6C6CFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5728,
  stopColor: "#19194F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8572,
  stopColor: "#6C6CFF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_7282_32570",
  x1: 169.043,
  y1: 246.705,
  x2: 143.625,
  y2: 325.992,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.135417,
  stopColor: "#595DF9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCCDFD",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CCCDFD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_7282_32570",
  x1: 141.042,
  y1: 243.611,
  x2: 187.542,
  y2: 277.611,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0F1048"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#0F1048",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_7282_32570",
  x1: 97.6844,
  y1: 100.748,
  x2: 130.438,
  y2: 90.4431,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDBC9D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F49A89"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_7282_32570",
  x1: 128.322,
  y1: 72.7299,
  x2: 144.921,
  y2: 97.4754,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDBC9D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F49A89"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_7282_32570",
  x1: 142.335,
  y1: 171.242,
  x2: 142.518,
  y2: 123.408,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDBC9D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F49A89"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_7282_32570",
  x1: 171.328,
  y1: 61.3859,
  x2: 161.932,
  y2: 102.233,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDBC9D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F49A89"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint11_linear_7282_32570",
  x1: 87.9917,
  y1: 117.925,
  x2: 118.102,
  y2: 108.452,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDBC9D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F49A89"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint12_linear_7282_32570",
  x1: 89.1858,
  y1: 17.648,
  x2: 89.1858,
  y2: 46.3415,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#323180"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A4CA7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint13_linear_7282_32570",
  x1: 142.128,
  y1: 33.8395,
  x2: 142.128,
  y2: 62.533,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#323180"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A4CA7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint14_linear_7282_32570",
  x1: 113.714,
  y1: 47.2404,
  x2: 116.367,
  y2: 196.989,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0816486,
  stopColor: "#282B73"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4D3FA4"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint15_linear_7282_32570",
  x1: 86.6443,
  y1: 17,
  x2: 86.6443,
  y2: 45.6935,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6467EF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A4CA7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint16_linear_7282_32570",
  x1: 139.644,
  y1: 33,
  x2: 139.644,
  y2: 61.6935,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#6467EF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4A4CA7"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint17_linear_7282_32570",
  x1: 164.559,
  y1: 181.018,
  x2: 175.337,
  y2: 162.456,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5F4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint18_linear_7282_32570",
  x1: 190.048,
  y1: 172.514,
  x2: 214.882,
  y2: 148.575,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5F4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint19_linear_7282_32570",
  x1: 213.984,
  y1: 180.129,
  x2: 243.068,
  y2: 159.993,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4F3FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint20_linear_7282_32570",
  x1: 180.687,
  y1: 105.911,
  x2: 187.61,
  y2: 93.9889,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5F4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint21_linear_7282_32570",
  x1: 197.057,
  y1: 100.449,
  x2: 213.007,
  y2: 85.0734,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5F4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint22_linear_7282_32570",
  x1: 212.43,
  y1: 105.34,
  x2: 231.11,
  y2: 92.4072,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4F3FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint23_linear_7282_32570",
  x1: 217.979,
  y1: 136.428,
  x2: 221.954,
  y2: 129.582,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5F4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint24_linear_7282_32570",
  x1: 227.379,
  y1: 133.292,
  x2: 236.537,
  y2: 124.463,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E5F4FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint25_linear_7282_32570",
  x1: 236.208,
  y1: 136.1,
  x2: 246.934,
  y2: 128.674,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E4F3FE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "white",
  stopOpacity: 0
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccountLiveViewEmptyState);
export default ForwardRef;